var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.146 4.64601C2.19245 4.59945 2.24762 4.5625 2.30837 4.5373C2.36911 4.51209 2.43423 4.49911 2.5 4.49911C2.56577 4.49911 2.63089 4.51209 2.69163 4.5373C2.75238 4.5625 2.80756 4.59945 2.854 4.64601L6 7.79301L9.146 4.64601C9.23989 4.55212 9.36723 4.49938 9.5 4.49938C9.63278 4.49938 9.76011 4.55212 9.854 4.64601C9.94789 4.7399 10.0006 4.86723 10.0006 5.00001C10.0006 5.13278 9.94789 5.26012 9.854 5.35401L6.354 8.85401C6.30756 8.90057 6.25238 8.93751 6.19164 8.96272C6.13089 8.98793 6.06577 9.0009 6 9.0009C5.93423 9.0009 5.86911 8.98793 5.80837 8.96272C5.74762 8.93751 5.69245 8.90057 5.646 8.85401L2.146 5.35401C2.09944 5.30756 2.0625 5.25239 2.03729 5.19164C2.01208 5.1309 1.99911 5.06578 1.99911 5.00001C1.99911 4.93424 2.01208 4.86912 2.03729 4.80837C2.0625 4.74763 2.09944 4.69245 2.146 4.64601Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownArrow);
export default __webpack_public_path__ + "static/media/black-down-arrow.2866971dd0bb5bc2aab724e0d0b04700.svg";
export { ForwardRef as ReactComponent };